import { changeLayoutModeAction, changeLayoutSidebarSizeAction } from "./reducer";
import { changeHTMLAttribute } from "./utils";

export const changeLayoutMode = (layoutMode: any) => async (dispatch: any) => {
  try {
    changeHTMLAttribute("data-mode", layoutMode);

    if (layoutMode === "dark") {
      changeHTMLAttribute("data-sidebar", "dark");
      changeHTMLAttribute("data-topbar", "dark");
    } else {
      changeHTMLAttribute("data-sidebar", "light");
      changeHTMLAttribute("data-topbar", "light");
    }

    try {
      localStorage.setItem("app-theme", layoutMode);
    } catch (storageError) {
      console.warn("Erro ao salvar tema no localStorage:", storageError);
    }

    dispatch(changeLayoutModeAction(layoutMode));
  } catch (error) {
    console.warn("Erro ao alterar tema:", error);
  }
};

export const changeLeftsidebarSizeType = (leftsidebarSizetype: any) => async (dispatch: any) => {
  try {
    switch (leftsidebarSizetype) {
      case "lg":
        changeHTMLAttribute("data-sidebar-size", "lg");
        break;
      case "sm":
        changeHTMLAttribute("data-sidebar-size", "sm");
        break;
      default:
        changeHTMLAttribute("data-sidebar-size", "lg");
    }
    dispatch(changeLayoutSidebarSizeAction(leftsidebarSizetype));
  } catch (error) {
    console.warn("Erro ao alterar sidebar:", error);
  }
};
